import { isSerializable } from '../types.js';
export class Destination {
    /**
     * Apply data transformations on an action, in this order:
     * 1. User-defined transform function (when specified)
     * 2. Standard base destination transform
     * @param action the `Action` instance to transform
     * @param properties any extra properties to include such as globalActionProperties and userTraits
     * @returns a serializable object prepared to be sent to the destination
     */
    async transform(action, { globalActionProperties = {}, userTraits = {} }) {
        const destination = action.destinations?.find(dest => dest.name === this.name);
        if (destination && 'transformer' in destination && destination.transformer != null) {
            // Apply custom transforms defined by the Action
            const payload = {
                ...(await destination.transformer(action.data, globalActionProperties)),
                ...userTraits
            };
            if (isSerializable(payload)) {
                // Then apply the Destination's standard transforms
                return this.baseTransform(action, payload);
            }
            throw new Error('The transform function must return a serializable object', { cause: payload });
        }
        const payload = {
            ...globalActionProperties,
            ...userTraits,
            ...action.data
        };
        if (isSerializable(payload)) {
            return this.baseTransform(action, payload);
        }
        throw new Error('The action data must be serializable', { cause: payload });
    }
}
//# sourceMappingURL=Destination.js.map